import { Fragment, useMemo } from 'react'
import isEmpty from 'ramda/es/isEmpty'

import { Table, useCopyColumnsWidths } from 'app/common/ui-components/table'
import CSSSticky from 'app/common/ui-components/css-sticky'
import EmptyWarn from 'app/common/layouts/EmptyWarn'
import Loading from 'app/common/components/Loader'
import { HeaderContent } from 'app/common/layouts/RowLayout'
import { useCurrencySign } from 'app/common/components-next/currency'

import type { PurchaseItem } from '../ordersPurchasesConvert'
import { OOPByComplexesHead } from './OOPByComplexesHead'
import { OOPByComplexesRow } from './OOPByComplexesRow'
import { OOPResultHeader } from './OOPResultHeader'
import { getTitles } from './columnsByComplexes'

import styles from './OOPByComplexes.scss'


type Props = {
  items: Array<PurchaseItem>
  loading: boolean
  reportId: number
  reportFileName: string
}

export const OOPByComplexes = ({
  items,
  loading,
  reportId,
  reportFileName,
}: Props) => {
  const currency = useCurrencySign()
  const titles = getTitles(currency)

  const nothing = isEmpty(items)

  const updateKey = useMemo(() => ([]), [items]) // eslint-disable-line react-hooks/exhaustive-deps
  const [refFrom, refTo] = useCopyColumnsWidths(updateKey)

  return (
    <Fragment>
      <CSSSticky
        number={4}
        className={styles.stickable}
        shadowClassName={styles.shadow}
        stickyClassName={styles.sticky}
      >
        <OOPResultHeader
          reportId={reportId}
          reportFileName={reportFileName}
          className={styles.topBorderOnSticky}
        />
        <HeaderContent paddingfree>
          <Table className={styles.table}>
            <thead>
              <OOPByComplexesHead
                reference={refTo}
                titles={titles}
              />
            </thead>
          </Table>
        </HeaderContent>

        {loading
          && !nothing
          && <Loading className={styles.loadingOverContent} />}
      </CSSSticky>

      {nothing
        && loading
        && <Loading />}

      {nothing
        && !loading
        && <EmptyWarn>{'Нет записей, удовлетворяющих условиям'}</EmptyWarn>}

      {!nothing
        && <Table className={styles.table}>
          <thead>
            <OOPByComplexesHead
              reference={refFrom}
              titles={titles}
              hidden
            />
          </thead>
          <tbody>
            {items.map(item => (
              <OOPByComplexesRow
                key={item.id}
                disabled={loading}
                {...item}
              />
            ))}
          </tbody>
        </Table>}
    </Fragment>
  )
}
